import React from 'react';
import { Row, Col } from 'react-bootstrap';
import SkeletonCard from './SkeletonCard';

const AllCards = ({ children }) => (
  <React.Fragment>
    {[...Array(2).keys()].map((ele) =>
      <Row key={ele}>
        {[...Array(3).keys()].map((ele) =>
          <Col key={ele} md={4}>
            <SkeletonCard>{children}</SkeletonCard>
          </Col>)}
      </Row>
    )}
  </React.Fragment>
);

export default AllCards;



// WEBPACK FOOTER //
// ./src/components/Skeleton/AllCards.jsx